module.exports = __webpack_public_path__ + "img/landing-banner-2-mobile.3f977ed6.jpg";